import * as React from 'react';
import { IconButton, Box } from '@mui/material';
import Remove from '@material-ui/icons/Remove';
import AddCircleIcon from '@material-ui/icons/AddCircleRounded';
import AddIcon from '@material-ui/icons/Add';
import { Guid } from '../../../shared/utils';
import { useCallback, useState } from 'react';
import { InputType, TextInputField } from './TextInputField';
import { Button } from 'reactstrap';
import { useTranslations } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';


export interface DynamicRecordFieldProps {
    value: Record<string, string>,
    disabled?: boolean,
    type?: InputType,
    label: string,
    labelKey?: string,
    labelValue?: string,
    onChange: (value: Record<string, string>) => void,
    addButtonPosition?: 'label' | 'bottom',
}

export const DynamicRecordField = (props: DynamicRecordFieldProps) => {
    const t = useTranslations();
    const {
        value,
        type,
        label,
        labelKey,
        labelValue,
        onChange,
        disabled,
        addButtonPosition = 'label',
    } = props;

    const [values, _setValues] = useState(Object.fromEntries(Object.entries(value).map(([key, value]) => [Guid.newGuid(), {key, value}])))
    
    const setValues = useCallback((v: typeof values) => {
        _setValues(v)
        onChange(Object.fromEntries(Object.values(v).map(({key, value}) => [key, value])))
    }, [_setValues, onChange])

    const onAddNew = () => setValues({...values, [Guid.newGuid()]: {key: '', value: ''}})

    return (
        <div style={{display: 'flex', flexDirection: 'column', flexWrap: 'wrap', gap: 'var(--spacer-XS)'}}>
            {label &&
                <label style={{ fontSize: '0.8rem', }}>
                    {label} {!disabled && addButtonPosition === 'label' && <IconButton onClick={onAddNew} size="small"><AddCircleIcon/></IconButton>}
                </label>
            }
            {
                Object.entries(values).map(([id, {key, value}], idx) => (
                    <Box key={id} display="flex" gap={1} mb={1}>
                        <Box flex="1" maxWidth="45%">
                            <TextInputField
                                id={id ? `${id}-${idx}-key-input` : undefined}
                                disabled={disabled}
                                label={labelKey}
                                type='text'
                                value={key}
                                onChange={e => setValues({...values, [id]: {...values[id], key: e}})}
                            />
                        </Box>
                        <Box flex="1" maxWidth="45%">
                            <TextInputField
                                id={id ? `${id}-${idx}-input` : undefined}
                                disabled={disabled}
                                label={labelValue}
                                type={type || 'text'}
                                value={value}
                                onChange={e => setValues({...values, [id]: {...values[id], value: e}})}
                            />
                        </Box>
                        { !disabled && <Box>
                            <IconButton
                                id={id ? `${id}-${idx}-remove-button` : undefined}
                                size="small"
                                onClick={() => setValues(Object.fromEntries(Object.entries(values).filter(([i]) => i !== id)))}
                            >
                                <Remove/>
                            </IconButton>
                        </Box>}
                    </Box>
                ))
            }
            {!disabled && addButtonPosition === 'bottom' && (
                <Button color="link" size="sm" onClick={onAddNew}>
                    <AddIcon style={{ width: '1rem' }} />
                    {' '}{t(TK.add)}
                </Button>
            )}
        </div>
    );
}
